export default __webpack_public_path__ + "img/cnYlmqmN.9f0ff2f8.svg";